import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	selectedTitle: {
		color: tokens.colorCompoundBrandStrokeHover,
	},
	title: {
		color: "inherit",
	},
	burgerMenuButton: {
		paddingLeft: "18px"
	}
});
